var map = {
	"./flags/Afghanistan.png": 4489,
	"./flags/Afrique du Sud.png": 6622,
	"./flags/Albanie.png": 4400,
	"./flags/Algérie.png": 9960,
	"./flags/Allemagne.png": 6229,
	"./flags/Andorre.png": 4792,
	"./flags/Angleterre.png": 8038,
	"./flags/Angola.png": 6821,
	"./flags/Antigua-et-Barbuda.png": 5565,
	"./flags/Arabie Saoudite.png": 2862,
	"./flags/Argentine.png": 2397,
	"./flags/Arménie.png": 3086,
	"./flags/Aruba.png": 6529,
	"./flags/Athlètes Individuels Neutres.png": 2410,
	"./flags/Australie.png": 4129,
	"./flags/Autriche.png": 5595,
	"./flags/Azerbaïdjan.png": 5167,
	"./flags/Bahamas.png": 9951,
	"./flags/Bahreïn.png": 2743,
	"./flags/Bangladesh.png": 2039,
	"./flags/Barbade.png": 2457,
	"./flags/Belgique.png": 4743,
	"./flags/Belize.png": 2491,
	"./flags/Bermudes.png": 9090,
	"./flags/Bhoutan.png": 7000,
	"./flags/Birmanie.png": 8438,
	"./flags/Bolivie.png": 579,
	"./flags/Bosnie-Herzégovine.png": 8008,
	"./flags/Botswana.png": 1003,
	"./flags/Brunei.png": 5891,
	"./flags/Brésil.png": 7004,
	"./flags/Bulgarie.png": 6675,
	"./flags/Burkina Faso.png": 9258,
	"./flags/Burundi.png": 4168,
	"./flags/Bénin.png": 9267,
	"./flags/Cambodge.png": 5350,
	"./flags/Cameroun.png": 7304,
	"./flags/Canada.png": 3196,
	"./flags/Cap Vert.png": 9194,
	"./flags/Chili.png": 8409,
	"./flags/Chine.png": 4037,
	"./flags/Chypre.png": 5371,
	"./flags/Colombie.png": 8075,
	"./flags/Comores.png": 4510,
	"./flags/Corée du Nord.png": 4090,
	"./flags/Corée du Sud.png": 3745,
	"./flags/Costa Rica.png": 5584,
	"./flags/Croatie.png": 979,
	"./flags/Cuba.png": 9440,
	"./flags/Côte d'Ivoire.png": 1488,
	"./flags/Danemark.png": 5505,
	"./flags/Djibouti.png": 644,
	"./flags/Dominique.png": 8702,
	"./flags/Ecosse.png": 268,
	"./flags/Espagne.png": 7216,
	"./flags/Estonie.png": 2287,
	"./flags/Eswatini.png": 8846,
	"./flags/Fidji.png": 3213,
	"./flags/Finlande.png": 8212,
	"./flags/France.png": 3389,
	"./flags/Gabon.png": 513,
	"./flags/Gambie.png": 5816,
	"./flags/Ghana.png": 8243,
	"./flags/Gibraltar.png": 7609,
	"./flags/Grande-Bretagne.png": 6273,
	"./flags/Grenade.png": 7330,
	"./flags/Grèce.png": 9533,
	"./flags/Guam.png": 1380,
	"./flags/Guatemala.png": 4194,
	"./flags/Guinée Equatoriale.png": 5297,
	"./flags/Guinée-Bissau.png": 3359,
	"./flags/Guinée.png": 244,
	"./flags/Guyana.png": 3160,
	"./flags/Géorgie.png": 6725,
	"./flags/Haiti.png": 5494,
	"./flags/Honduras.png": 2438,
	"./flags/Hong Kong.png": 1364,
	"./flags/Hongrie.png": 8577,
	"./flags/Inde.png": 8307,
	"./flags/Indonésie.png": 549,
	"./flags/Irak.png": 6947,
	"./flags/Iran.png": 6937,
	"./flags/Irlande du Nord.png": 602,
	"./flags/Irlande.png": 7049,
	"./flags/Islande.png": 4113,
	"./flags/Israël.png": 4054,
	"./flags/Italie.png": 5353,
	"./flags/Jamaïque.png": 4261,
	"./flags/Japon.png": 8864,
	"./flags/Jordanie.png": 5605,
	"./flags/Kazakhstan.png": 5465,
	"./flags/Kenya.png": 8498,
	"./flags/Kirghizistan.png": 6861,
	"./flags/Kiribati.png": 1415,
	"./flags/Kosovo.png": 7314,
	"./flags/Koweït.png": 8752,
	"./flags/Laos.png": 7521,
	"./flags/Lettonie.png": 8749,
	"./flags/Liban.png": 7601,
	"./flags/Liberia.png": 5640,
	"./flags/Libye.png": 9830,
	"./flags/Liechtenstein.png": 5161,
	"./flags/Lituanie.png": 7971,
	"./flags/Luxembourg.png": 7176,
	"./flags/Macédoine du Nord.png": 6546,
	"./flags/Madagascar.png": 4762,
	"./flags/Malaisie.png": 6243,
	"./flags/Malawi.png": 2309,
	"./flags/Maldives.png": 172,
	"./flags/Mali.png": 6288,
	"./flags/Malte.png": 1636,
	"./flags/Maroc.png": 6123,
	"./flags/Maurice.png": 7192,
	"./flags/Mauritanie.png": 8346,
	"./flags/Mexique.png": 5293,
	"./flags/Micronésie.png": 5449,
	"./flags/Moldavie.png": 5820,
	"./flags/Monaco.png": 2320,
	"./flags/Mongolie.png": 9483,
	"./flags/Monténégro.png": 2139,
	"./flags/Mozambique.png": 4837,
	"./flags/Namibie.png": 2308,
	"./flags/Nauru.png": 1595,
	"./flags/Nicaragua.png": 9003,
	"./flags/Niger.png": 5835,
	"./flags/Nigeria.png": 3525,
	"./flags/Norvège.png": 8127,
	"./flags/Nouvelle-Zélande.png": 3344,
	"./flags/Népal.png": 2706,
	"./flags/Oman.png": 235,
	"./flags/Ouganda.png": 7773,
	"./flags/Ouzbékistan.png": 6246,
	"./flags/Pakistan.png": 7302,
	"./flags/Palaos.png": 5764,
	"./flags/Palestine.png": 6713,
	"./flags/Panama.png": 5808,
	"./flags/Papouasie-Nouvelle-Guinée.png": 2258,
	"./flags/Paraguay.png": 1465,
	"./flags/Pays de Galles.png": 4239,
	"./flags/Pays-Bas.png": 3785,
	"./flags/Philippines.png": 1598,
	"./flags/Pologne.png": 5643,
	"./flags/Porto Rico.png": 8554,
	"./flags/Portugal.png": 4704,
	"./flags/Pérou.png": 6893,
	"./flags/Qatar.png": 3059,
	"./flags/Roumanie.png": 5452,
	"./flags/Russie.png": 2478,
	"./flags/Rwanda.png": 2247,
	"./flags/République Dominicaine.png": 5075,
	"./flags/République Démocratique du Congo.png": 431,
	"./flags/République du Congo.png": 9053,
	"./flags/Saint-Christophe-et-Niévès.png": 6660,
	"./flags/Saint-Marin.png": 4404,
	"./flags/Saint-Vincent-et-les-Grenadines.png": 9838,
	"./flags/Sainte-Lucie.png": 3933,
	"./flags/Salomon.png": 6775,
	"./flags/Salvador.png": 3021,
	"./flags/Samoa américaines.png": 8327,
	"./flags/Samoa.png": 1786,
	"./flags/Sao Tomé-et-Principe.png": 6639,
	"./flags/Serbie.png": 4058,
	"./flags/Seychelles.png": 5803,
	"./flags/Sierra Leone.png": 3335,
	"./flags/Singapour.png": 4984,
	"./flags/Slovaquie.png": 2017,
	"./flags/Slovénie.png": 8965,
	"./flags/Somalie.png": 3804,
	"./flags/Soudan du Sud.png": 9687,
	"./flags/Soudan.png": 2677,
	"./flags/Sri Lanka.png": 6957,
	"./flags/Suisse.png": 5646,
	"./flags/Suriname.png": 3565,
	"./flags/Suède.png": 5299,
	"./flags/Syrie.png": 2210,
	"./flags/Sénégal.png": 2734,
	"./flags/Tadjikistan.png": 7771,
	"./flags/Taipei Chinois.png": 9675,
	"./flags/Tanzanie.png": 934,
	"./flags/Tchad.png": 1770,
	"./flags/Tchéquie.png": 2756,
	"./flags/Thaïlande.png": 2317,
	"./flags/Timor oriental.png": 6696,
	"./flags/Togo.png": 8341,
	"./flags/Tonga.png": 7120,
	"./flags/Trinité-et-Tobago.png": 3599,
	"./flags/Tunisie.png": 6446,
	"./flags/Turkménistan.png": 8203,
	"./flags/Turquie.png": 2276,
	"./flags/Tuvalu.png": 2124,
	"./flags/Ukraine.png": 4668,
	"./flags/Uruguay.png": 8755,
	"./flags/Vanuatu.png": 7363,
	"./flags/Venezuela.png": 4937,
	"./flags/Viêt Nam.png": 5496,
	"./flags/Yémen.png": 9512,
	"./flags/Zambie.png": 2866,
	"./flags/Zimbabwe.png": 2290,
	"./flags/Égypte.png": 2153,
	"./flags/Émirats Arabes Unis.png": 3530,
	"./flags/Équateur.png": 8971,
	"./flags/Équipe Olympique des Réfugiés.png": 5897,
	"./flags/Érythrée.png": 3657,
	"./flags/États-Unis.png": 5604,
	"./flags/Éthiopie.png": 2676,
	"./flags/Îles Caïmans.png": 1571,
	"./flags/Îles Cook.png": 866,
	"./flags/Îles Marshall.png": 2119,
	"./flags/Îles Vierges britanniques.png": 200,
	"./flags/Îles Vierges des États-Unis.png": 491,
	"./gamefacts/medal/medal_bronze.png": 6042,
	"./gamefacts/medal/medal_gold.png": 6982,
	"./gamefacts/medal/medal_silver.png": 1715,
	"./pro/dsas.png": 9351,
	"./pro/opta.png": 1875
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7003;